<template>
  <div>
    <form
      class="
        layout/flex:column
        layout/grid:gap:page:2
      "
      autocapitalize="none"
      autocomplete="off"
      autocorrect="off"
      action="/artists/"
      accept-charset="UTF-8"
      method="get"
      @submit.prevent="onSubmit"
      >
      <div
        class="
          color/background
          $color/background:gray:eee
          $color/background:alpha:54%
        "
        >
        <div
          class="
            layout/flex:column
            layout/align:start
            layout/grid:gap:page
            layout/padding:top:page
            layout/padding:bottom:page
            layout/wrapper
          "
          >
          <SearchInput
            ref="input"
            :input-placeholder="i18n.t('collection__artists__index__search_placeholder')"
            :value="q"
            aria-label-input="Press return to search."
            aria-label-reset="Clear search terms."
            gtm="artists / search"
            @searchInput="(val) => $emit('search-input', val)"
            @searchReset="$emit('search-reset')"
          />
          <div
            class="
              @480/layout/align:center
              @480/layout/flex:row
              layout/align:start
              layout/flex:column
              layout/grid:gap:page
              layout/justify:between
              layout/width:100%
            "
            >
            <Checkbox
              :checked="withOnlineWorks"
              :label="i18n.t('collection__artists__index__with_online_works')"
              checkbox-name="with_online_works"
              gtm="artists / online works"
              @clickedCheckbox="(val) => $emit('update-checked', val)"
            />
            <Sort
              :random="random"
              :search-val="q"
              @sort="(val) => $emit('update-sort', val)"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  /**
   * ArtistFilterForm is a proxy component that just emits changes from child components
   * up to ArtistFormWrapper to manage.
   */
  import Checkbox from 'Components/form/checkbox.vue';
  import SearchInput from 'Components/form/search-input.vue';
  import i18n from 'Utils/i18n.js';
  import Sort from "./sort.vue";

  export default {
    components: {
      Checkbox,
      SearchInput,
      Sort
    },
    props: {
      q: { type: String, required: true },
      random: { type: Number, required: true },
      withOnlineWorks: { type: Boolean, required: true },
    },
    data() {
      return {
        i18n: new i18n(),
      };
    },
    methods: {
      onSubmit() {
        this.$refs.input.blurInput();
        this.$emit('form-submit');
      }
    }
  };
</script>
